<template>
  <span v-if="isDisabled">
    <lp-tooltip :content="tooltipMessage" :placement="tooltipPlacement">
      <lp-checkbox :model-value="modelValue" disabled :label="label" />
    </lp-tooltip>
  </span>
  <span v-else>
    <lp-checkbox
      :model-value="modelValue"
      :label="label"
      @update:model-value="updateValue"
    />
  </span>
</template>

<script setup lang="ts">
import { Positions } from '../../models/enums/Positions'
import { t } from '@/plugins/i18n'

withDefaults(
  defineProps<{
    modelValue: boolean
    isDisabled?: boolean
    tooltipMessage?: string
    tooltipPlacement?: Positions
    label?: string
  }>(),
  {
    isDisabled: false,
    tooltipMessage: t('Shared.Disabled'),
    tooltipPlacement: Positions.TR,
    label: '',
  },
)

const emit = defineEmits<{
  (e: 'update:model-value', value: boolean): void
}>()

function updateValue(value: boolean) {
  emit('update:model-value', value)
}
</script>
